// Shared Chart.js option factories.
//
// The bar charts across the app used to copy-paste almost identical option
// objects (max: 5, tick color "1e1e1e", font size 15, the "bar-x-axis1"
// secondary axis, indexAxis "y", etc.). These factories centralise that
// configuration so the wrapper components only have to describe what is
// genuinely different for their use case.

const TICK_COLOR = "1e1e1e";
const TICK_FONT_SIZE = 15;
const MAX_SCORE = 5;

const scoreTicks = () => ({
  color: TICK_COLOR,
  font: {
    size: TICK_FONT_SIZE,
  },
});

/**
 * Options for a vertical (default) bar chart with a 0-5 score scale.
 * @param {Object} overrides shallow-merged on top of the defaults.
 */
export function verticalBarOptions(overrides = {}) {
  return {
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: !!overrides.title,
        fullSize: true,
        text: overrides.title,
        color: 'black',
        padding: {
          top: 10,
          bottom: 30,
        },
        font: {
          size: 22,
          family: 'Verdana',
        }
      },
    },
    scales: {
      r: {
        suggestedMin: 0,
        suggestedMax: 5,
      },
      x: {
        ticks: scoreTicks(),
      },
      "bar-x-axis1": {
        display: false,
        ticks: scoreTicks(),
      },
      y: {
        max: MAX_SCORE,
        ticks: scoreTicks(),
      },
    },
    ...overrides,
  };
}

/**
 * Options for a horizontal bar chart (indexAxis "y") with a 0-5 score scale,
 * a top primary x-axis and a mirrored bottom "bar-x-axis1".
 * @param {Object} overrides shallow-merged on top of the defaults.
 */
export function horizontalBarOptions(overrides = {}) {
  return {
    indexAxis: "y",
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        stacked: false,
        type: "linear",
        id: "x-axis-1",
        position: "top",
        max: MAX_SCORE,
        ticks: scoreTicks(),
      },
      "bar-x-axis1": {
        max: MAX_SCORE,
        axis: "x",
        position: "bottom",
        grid: {
          drawOnChartArea: false,
        },
        ticks: scoreTicks(),
      },
      y: {
        ticks: {
          color: TICK_COLOR,
          autoSkip: false,
        },
      },
    },
    ...overrides,
  };
}
